export default "__VITE_ASSET__4b68830c__"